
namespace RioERP.Inventory {

    @Serenity.Decorators.registerClass()
    export class PendriveInwardGrid extends Serenity.EntityGrid<PendriveInwardRow, any> {
        protected getColumnsKey() { return PendriveInwardColumns.columnsKey; }
        protected getDialogType() { return PendriveInwardDialog; }
        protected getIdProperty() { return PendriveInwardRow.idProperty; }
        protected getInsertPermission() { return PendriveInwardRow.insertPermission; }
        protected getLocalTextPrefix() { return PendriveInwardRow.localTextPrefix; }
        protected getService() { return PendriveInwardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}